/**
 * src/connects/chat-room-form-panel.js
 */

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import uploadFiles from '../helpers/file-upload'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import componentId from '../helpers/component-id'
import combineHOC from '../helpers/combine-hoc'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'

export const mapStateToProps = (state, ownProps)=> {
  return {
    name: ownProps.chatRoom && ownProps.chatRoom.name || undefined,
    _uploadFile: state.uploadFile[ownProps.componentId],
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var uploadFile
  if (stateProps._uploadFile) {
    uploadFile = find(stateProps._uploadFile, (value, key)=> value)
  }

  return {
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item,
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    validateAndSubmit: (props, callback, event = undefined, crop) => {
      if (event && event.preventDefault)
        event.preventDefault()

      validate(props.ui, { name: { rule: 'isRequired' },}, (errors, nextUI)=> {
        props.updateUI(nextUI)
        if (!errors) {
          callback && callback()
          dispatch(actions.updateChatRoom(
            props.chatRoom.chat_room_id,
            props.ui.name,
            props.uploadedFile && props.uploadedFile.file_id,
            crop
          ))
          dispatch(emitAlertMessage({ message: 'label:チャットルーム名を変更', name: props.ui.name }, 'success'))
        }
      })

      return false
    },

    uploadFile: (props, file)=> !props.isUploading && uploadFiles(
      file, dispatch, props.chatRoom.chat_room_id, 'chat_room',
      ownProps.componentId, true
    )
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ 
    state: {
      name: (props)=> props.name,
      nameError: undefined,
    }
  }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/chat-room-form-panel.js